import { MediaContext } from 'contexts/MediaContext';
import { useContext } from 'react';

const useMedia = () => useContext(MediaContext);

export default useMedia;
